import React, { createContext } from 'react'
import { FeatureResponse } from '../utils/fetchModalData'

export interface FeatureContext {
  featureData: { [key: string]: FeatureResponse }
  featureKeys: string[]
  unreadFeatures: string[]
  featureOpen: boolean
  featureId: string
  featureLabels: any
  featureCloseEvent: (...args: any[]) => any
  setFeatureIdEvent: (...args: any[]) => any
}

export const FeatureContext = createContext<FeatureContext>({
  featureData: {},
  featureKeys: [],
  unreadFeatures: [],
  featureOpen: false,
  featureId: '',
  featureLabels: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  featureCloseEvent: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setFeatureIdEvent: () => {},
})

export const FeatureContextProvider: React.FC<{ value: FeatureContext }> = ({ children, value }) => {
  return <FeatureContext.Provider value={value}>{children}</FeatureContext.Provider>
}

export const useFeatureContext = (): FeatureContext => {
  const context = React.useContext(FeatureContext)
  if (!context) {
    throw new Error('useFeatureContext must be used within a FeatureContext.Provider')
  }
  return context
}
